import { render, staticRenderFns } from "./receipt-card.vue?vue&type=template&id=6610d798"
import script from "./receipt-card.vue?vue&type=script&lang=js"
export * from "./receipt-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports